import React from 'react';
import PropTypes from 'prop-types';
import ENUMS from '../../../enums/index';
import { roles } from '../../../enums/roles';
import Spin from '../../../components/loading';
import './details.scss';

const UserBasicInfo = ({
                         loading,
                         avatarUrl,
                         birthDate,
                         firstName,
                         lastName,
                         gender,
                         maritalStatus,
                         marriageDate,
                         mobileNumber,
                         email,
                         cafeId,
                         cafeNamesList,
                         roleId,
                       }) => {
  const role = roleId ? roles?.[roleId]?.title : '';
  return (
    <Spin spinning={loading}>
      <main className="p-0 col-12" style={{ backgroundColor: 'white' }}>
        <div className="col-12 p-0 d-flex">
          {/* user avatar part */}
          <div className="d-flex align-center" style={{ alignItems: 'center' }}>
            <img
              className="avatarSize"
              src={avatarUrl.length ? avatarUrl : require('../../../assets/icons/userDefault.png')}
              alt="user-avatar"
            />
          </div>
          {/* user avatar part end */}

          <div className="p-0 col-10">
            <div className="col-12 d-flex py-4">
              {/* name part */}
              <div className="p-2 col-3">
                <span>{locales('titles.userFullName')} :</span>
                <span>{`  ${firstName} ${lastName}`}</span>
              </div>
              {/* name part end */}

              {/* birth date part */}
              <div className="p-2 col-3">
                <span>{locales('titles.birthDate')} :</span>
                <span className="px-1">{birthDate || '---'}</span>
              </div>
              {/* birth date part end */}

              {/* marraige Status part */}
              <div className="p-2 col-3 d-flex">
                <span>{locales('titles.marriageStatus')} :</span>
                <span className="px-1 d-flex">
                  {ENUMS.MARRIAGE_STATUS.list.map((marriage, index) => (
                    <div key={index}>
                      <label htmlFor={`marriageStatus-${index}`} className="px-2">
                        {marriage.title}
                      </label>
                      <input
                        id={`marriageStatus-${index}`}
                        type="checkbox"
                        checked={marriage.value === maritalStatus}
                        disabled
                      />
                    </div>
                  ))}
                </span>
                {/* marraige Status part end */}
              </div>

              {/* cafe name part */}
              <div className="p-2 col-3">
                <span>{locales('tables.role')} :</span>
                <span className="px-1">
                  {`${role} ${cafeId ? cafeNamesList.find(item => item.id === cafeId).name : '---'}`}
                </span>
              </div>
              {/* cafe name part end */}
            </div>

            <div className="col-12 d-flex">
              {/* mobile number part */}
              <div className="p-2 col-3">
                <span>{locales('fields.mobileNumber')} :</span>
                <span>{`  ${mobileNumber}`}</span>
              </div>
              {/* mobile number part end */}

              {/* gender part */}
              <div className="p-2 col-3 d-flex">
                <span>{locales('titles.gender')} :</span>
                <span className="px-1 d-flex">
                  {ENUMS.GENDERS.list.map((enumGender, genderIndex) => (
                    <div key={genderIndex}>
                      <label htmlFor={`gender-${genderIndex}`} className="px-2">
                        {enumGender.title}
                      </label>
                      <input
                        id={`gender-${genderIndex}`}
                        type="checkbox"
                        checked={enumGender.value == gender}
                        disabled
                      />
                    </div>
                  ))}
                </span>
              </div>
              {/* gender part end */}

              {/* marriage date  part */}
              <div className="p-2 col-3">
                <span>{locales('titles.marriageDate')} :</span>
                <span>{`  ${marriageDate || '---'}`}</span>
              </div>
              {/* marriage date part end */}

              {/* email  part */}
              <div className="p-2 col-3">
                <span>{locales('messages.email')} :</span>
                <span>{`  ${email}`}</span>
              </div>
              {/* email part end */}
            </div>
          </div>
        </div>
      </main>
    </Spin>
  );
};

UserBasicInfo.propTypes = {
  avatarUrl: PropTypes.string,
  birthDate: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  gender: PropTypes.string,
  maritalStatus: PropTypes.string,
  marriageDate: PropTypes.string,
  mobileNumber: PropTypes.string,
  email: PropTypes.string,
};
UserBasicInfo.defaultProps = {
  avatarUrl: require('../../../assets/icons/userDefault.png'),
  birthDate: '---',
  firstName: '---',
  lastName: '---',
  gender: 'MALE',
  maritalStatus: 'SINGLE',
  marriageDate: '---',
  mobileNumber: '---',
  email: '---',
};
export default UserBasicInfo;
